import React, { useEffect, useState } from 'react';
import { AnimatedCheckScreen } from 'components/screens';
import SelectCardProvider from './SelectCardProvider';
import SelectCardPage from './SelectCard';
import ShowCardBenefitsPage from './SelectCardBenefits';
import { ICreditCard, IUser } from 'types';
import styles from './exploreCC.scss';
import { trackEvent } from 'helpers';

interface IExploreCreditCardsProps {
  creditCards: ICreditCard[];
  submitted: boolean;
  submitting: boolean;
  user: IUser;
  createCreditCardPolicy(creditCard: ICreditCard): void;
  resetForm(): void;
  handleBack: () => void;
}

const ExploreCreditCards = ({
  creditCards,
  submitted,
  submitting,
  user,
  createCreditCardPolicy,
  resetForm,
  handleBack,
}: IExploreCreditCardsProps) => {
  const [providerName, setProviderName] = useState('');
  const [selectedCard, setSelectedCard] = useState(null);

  useEffect(() => resetForm, []);

  const handleSelectProvider = (provider: string) => {
    trackEvent('Web-App-Select-CC-Provider', { provider });
    setSelectedCard(null);
    setProviderName(provider);
  };

  const handleSelectCard = (data: ICreditCard) => {
    trackEvent('Web-App-Select-CC', data);
    setSelectedCard(data);
  };

  if (submitted) {
    return <AnimatedCheckScreen onFinish={handleBack} timer={3000} />;
  }

  return (
    <>
      <SelectCardProvider
        selectProvider={handleSelectProvider}
        providerName={providerName}
      />
      <div className={styles.content}>
        {providerName && (
          <SelectCardPage
            selectCard={handleSelectCard}
            providerName={providerName}
            selectedCard={selectedCard}
            creditCards={creditCards}
          />
        )}
        {selectedCard && (
          <ShowCardBenefitsPage
            createPolicy={createCreditCardPolicy}
            providerName={providerName}
            creditCard={selectedCard}
            user={user}
            loading={submitting}
          />
        )}
      </div>
    </>
  );
};

export default ExploreCreditCards;
